import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cancel: 'Later',
    confirm: 'Convert to invoice',
    description:
      'Simplify the process by turning your quote into an invoice in just a few clicks or choose to do it later.',
    errorMessage:
      'An error occurred while creating your invoice. Please try again in a few minutes and don’t hesitate to contact us if the error remains.',
    title: 'Convert your quote to an invoice',
  },
  fr: {
    cancel: 'Plus tard',
    confirm: 'Convertir en facture',
    description:
      'Simplifiez vos démarches en transformant votre devis en facture en quelques clics ou choisissez de le faire plus tard.',
    errorMessage:
      'Une erreur est survenue lors de la création de votre facture. Essayez à nouveau dans quelques minutes et n’hésitez pas à nous contacter si le problème persiste.',
    title: 'Convertissez votre devis en facture',
  },
} as const);
